import {RouteRecordRaw} from 'vue-router';

export default function (rootName: string): RouteRecordRaw[] {
    return [
        {
            path: `vehicles-drivers-filter`,
            name: `${rootName}VehiclesDriversFilter`,
            component: () =>
                import(
                    '../../planning-tool/components/schedule/components/vehicle-driver-filter/VehicleDriverFilterForm.vue'
                ),
            props: (route) => {
                return Object.assign({
                    backRouteName: rootName
                });
            }
        }
    ];
}
